import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { ConstructorState } from './types'
import { IConstructorTemplate } from '@/types/constructor-template.interface'
import { IConstructorFaq, IConstructorFaqCategory } from '@/types/constructor-faq.interface'

const initialState: ConstructorState = {
  templates: [],
  faqs: [],
  faqCategories: [],
}

const constructorDataSlice = createSlice({
  name: 'constructor-data',
  initialState,
  reducers: {
    setConstructorTemplates(state, action: PayloadAction<IConstructorTemplate[]>) {
      state.templates = action.payload
    },
    setConstructorFaqs(state, action: PayloadAction<IConstructorFaq[]>) {
      state.faqs = action.payload
    },
    setConstructorFaqCategories(state, action: PayloadAction<IConstructorFaqCategory[]>) {
      state.faqCategories = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.constructorData,
      }
    })
  },
})

export const { setConstructorFaqs, setConstructorTemplates, setConstructorFaqCategories } =
  constructorDataSlice.actions

export default constructorDataSlice
